(ns ui.docs-panel
  (:require [ui.typography :as typography]
            [ui.utils :refer [clsx separate-props]]))

(defn _ [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "" %))]
          children)))

(defn header [& args]
  (let [[props children] (separate-props args)]
    (into [:header (update props :class #(clsx "" %))]
          children)))

(defn title [& args]
  (let [[props children] (separate-props args)]
    (into [typography/h2 (update props :class #(clsx "" %))]
          children)))

(defn description [& args]
  (let [[props children] (separate-props args)]
    (into [typography/p (update props :class #(clsx "text-base text-kleene-text-secondary" %))]
          children)))

(defn actions [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "flex gap-2 mt-4" %))]
          children)))

(defn panel [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "px-8 py-6 flex-auto gap-2 justify-between" %))]
          children)))

(defn content [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "flex flex-col gap-8 mt-8 text-base" %))]
          children)))

(defn section-title [& args]
  (let [[props children] (separate-props args)]
    (into [typography/h3 (update props :class #(clsx "mb-1" %))]
          children)))

(defn details [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "bg-kleene-background-secondary rounded-lg p-4" %))]
          children)))

(defn details-title [& args]
  (let [[props children] (separate-props args)]
    (into [typography/h4 props]
          children)))

(defn details-content [& args]
  (let [[props children] (separate-props args)]
    (into [:div (update props :class #(clsx "mt-4 pt-4 border-t" %))]
          children)))
